import React from 'react';
import '../styles/Contact.css';
import '../styles/Breadcrumbs.css';
import Breadcrumbs from '../components/Breadcrumbs';
import FabHelp from '../components/FabHelp';

const ContactRow = ({ icon, label, children }) => (
  <div className="contact-row">
    <div className="contact-icon" aria-hidden>{icon}</div>
    <div className="contact-content">
      {label && <span className="contact-label">{label}</span>}
      <span className="contact-text">{children}</span>
    </div>
  </div>
);

const ContactPage = () => {
  const onFabClick = () => {
    const el = document.getElementById('distributor');
    if (!el) return;
    const headerHeight = 80;
    const targetPosition = el.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo(0, targetPosition);
  };

  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Contact Us' }]} />

      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-header">
            <h1 className="contact-title">Industry Max L.L.C</h1>
          </div>
          <div className="contact-grid">
            <div className="contact-left">
              <ContactRow icon={<i className="fas fa-home" />} label="Address:">
                Meydan Free Zone, Dubai, UAE
              </ContactRow>
              <ContactRow icon={<i className="fas fa-envelope" />} label="Info:">
                 <span style={{ textTransform: "none" }}>info@industry-max.ae</span>
              </ContactRow>
              <ContactRow icon={<i className="fas fa-envelope" />} label="Sales:">
                 <span style={{ textTransform: "none" }}>sales@industry-max.ae</span>
              </ContactRow>
              <ContactRow icon={<i className="fas fa-phone-alt" />} label="Tel:">
                +971 586 686 710
              </ContactRow>
              {/* 
              <ContactRow icon={<i className="fab fa-whatsapp" />} label="WhatsApp:">
                +000
              </ContactRow>
              <ContactRow icon={<i className="far fa-envelope" />} label="Sales:">
                @
              </ContactRow>
              <ContactRow icon={<i className="far fa-envelope" />} label="After-sales:">
                @
              </ContactRow>
              <ContactRow icon={<i className="far fa-clock" />} label="Work Hours:">
                Mon-Sat 07:00 AM - 24:00 PM · Sun: Emergency inquiry
              </ContactRow>
              */}

              <div className="qr-grid">
                <div className="qr-item">
                  <div className="qr-box placeholder" />
                  <div className="qr-caption">WhatsApp</div>
                </div>
              </div>
            </div>

            <div className="contact-right">
              <div className="map-wrap">
                <iframe
                  title="Company Location"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps?q=Meydan%20Free%20Zone%20Dubai&output=embed"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </section>


      <section id="distributor" className="distributor-section">
        <div className="distributor-container">
          <div className="left">
          

            <div className="icon-text">
              <img
                src="https://img.icons8.com/ios-filled/50/0d3fa8/conference.png"
                alt="Technical Support"
              />
              <p>
                We have an excellent technical team dedicated to providing you with the support you need to grow
                your business.
              </p>
            </div>

            <div className="icon-text">
              <img
                src="https://img.icons8.com/ios-filled/50/0d3fa8/database.png"
                alt="Quality Products"
              />
              <p>We are committed to providing you with quality products and competitive prices.</p>
            </div>

            <div className="icon-text">
              <img
                src="https://img.icons8.com/ios-filled/50/0d3fa8/network.png"
                alt="High Quality"
              />
              <p>
                High-quality raw materials for a High service life,
                reducing maintenance costs.
              </p>
            </div>

           
          </div>

          <div className="form-box">
            <h3>Send An Inquiry</h3>
             <div className="inner">
               <p>
                 Are you struggling to find the right supplier and quality products? Tell Industry Max what you need
                 using the form below—our team will respond within 24 hours with exactly the information you require.
               </p>
              <form>
                <input type="text" placeholder="Name" />
                <input type="email" placeholder="*Email" required />
                <input type="text" placeholder="Phone/WhatsApp" />
                <input type="text" placeholder="Country" />
                <textarea placeholder="*Message" required></textarea>
                <button type="submit">
                  SEND <span>✈</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <FabHelp onClick={onFabClick} />
    </>
  );
};

export default ContactPage;
